import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useAllRPCIdsByPalette = (paletteId: string | undefined) : string[] => {
  const rpcDb = useSelector((state: RootState) => state.relationPaletteCardTemplateDb);
  const ids = Object.keys(rpcDb.relationPaletteCardTemplates).filter(id => rpcDb.relationPaletteCardTemplates[id].paletteId === paletteId);

  return ids;
}

export default useAllRPCIdsByPalette;
